var React = require('react');

function GradientMask (props) {
    return React.createElement("svg",props,React.createElement("defs",null,React.createElement("linearGradient",{"id":"department-icon-gradient","x1":"0%","x2":"100%","y1":"100%","y2":"0%","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0%","stopColor":"#00548F","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#13B2E8","key":1})])));
}

GradientMask.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = GradientMask;

GradientMask.default = GradientMask;
